// extracted by mini-css-extract-plugin
export default {"content":"LeftSidebar_content__lxnwM"};